import vue from 'vue'
import {apolloClient} from '@/graphql/apolloWrapper'
import {GET_PROCESS_BY_ID} from "../../graphql/queries/grab/fetchById";
import {GET_PROCESS_STATS} from "../../graphql/queries/grab/fetchStats";
import {GET_PROCESS_LIST} from "../../graphql/queries/grab/list";
import {GET_GENERAL_GRAB_INFO} from "../../graphql/queries/grab/fetchInfo";
import {COMMAND_JOB_CREATE} from '@/graphql/mutations/jobs/create'

const state = {
  info: {},
  processes: [],
  stats: {}
};

const getters = {
  inactiveProcesses: state => state.processes.filter(process => process.status !== 1),
  activeProcess: state => state.processes.find(process => process.status === 1),
  processById: state => id => state.processes.find(process => process.id === id),
  statsByProcess: state => id => state.stats[id],
  generalGrabInfo: state => state.info,
};

const mutations = {
  UPDATE_PROCESS_LIST: function (state, processes) {
    processes.forEach(process => {
      state.processes.upsert({id: process.id}, process);
    });
  },
  UPDATE_PROCESS_STATS: function (state, {id, stats}) {
    vue.set(state.stats, id, stats)
  },
  UPDATE_GENERAL_INFO: function (state, info) {
    state.info = info;
  }
};

const actions = {
  async processFetchList ({commit, dispatch}) {
    const {data} = await apolloClient.query({query: GET_PROCESS_LIST});
    if (data && data.grabGetProcessList) {
      commit('UPDATE_PROCESS_LIST', data.grabGetProcessList);
      console.log('processFetchList', data.grabGetProcessList);
      const activeProcess = data.grabGetProcessList.find(process => process.status === 1);
      if (activeProcess && activeProcess.id) {
        dispatch('processFetchById', activeProcess.id);
      }
      return true;
    }
    return false;
  },

  async processFetchById ({commit}, id) {
    const {data} = await apolloClient.query({query: GET_PROCESS_BY_ID, variables: {id: id}});
    if (data && data.grabGetProcessById) {
      commit('UPDATE_PROCESS_LIST', [data.grabGetProcessById]);
      return true;
    }
    return false;
  },
  async processFetchStats ({commit}, id) {
    const {data} = await apolloClient.query({query: GET_PROCESS_STATS, variables: {id: id}});
    if (data && data.grabGetProcessStats) {
      var response = JSON.parse(data.grabGetProcessStats);
      console.log('processFetchStats', response.stats);
      if (response.process_id && response.stats) {
        commit('UPDATE_PROCESS_STATS', {id: response.process_id, stats: response.stats});
      }
      return true;
    }
    return false;
  },
  async processFetchInfo ({commit}) {
    const {data} = await apolloClient.query({query: GET_GENERAL_GRAB_INFO});
    if (data && data.grabGetGeneralInfo) {
      var response = JSON.parse(data.grabGetGeneralInfo);
      if (response) {
        commit('UPDATE_GENERAL_INFO', response);
      }
      return true;
    }
    return false;
  },
  async processStart ({dispatch, commit}) {
    await apolloClient.mutate({
      mutation: COMMAND_JOB_CREATE,
      variables: {input: {action: 'grab_start'}}
    });
    setTimeout(() => {
      dispatch('processFetchList');
    }, 4000)
  },
  async processActiveUpdate ({dispatch, getters}) {
    dispatch('processFetchList');
    dispatch('processFetchStats');

    const activeProcess = getters.activeProcess;
    console.log('updater active process', activeProcess)
    if (activeProcess) {
      dispatch('logbookFetchList', activeProcess.id)
    }
  }

};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/grab.js